// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3fnjT","footer":"ModalInfo_footer__3rRlI"};